import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import modalHelper from '@appbase/util/modal-helper'
import { openReserveCalendarItem } from '@reserve/popup-handler'

import ModalLayout from '@appbase/templates/ModalLayout/ModalLayout.vue'

@Component({
    components: {
        ModalLayout
    }
})
export default class OccurrenceSelect  extends Vue {
    @Prop({ type: Object }) value!: reserve.CalendarItem

    masterOccurrence: string = "occurrence";

    onOpenClick() {
        // Exception인 경우에도 사용자가 선택한 값을 전달
        // 'occurrence'를 선택하면 'exception'으로 변환하여 전달
        let openValue = this.masterOccurrence;
        if (this.value.appointmentType === 'Exception' && this.masterOccurrence === 'occurrence') {
            openValue = 'exception';
        }
        openReserveCalendarItem(this.value, openValue);
        modalHelper.close();
    }

    onCancelClick() {
        modalHelper.close();
    }
}